export const fileTypeAcceptable = (accepts: string[], file: any) => {
  if (!accepts) {
     return true
  }

  return accepts.some((accept) => {
     if (file.type) {
        const [typeLeft, typeRight] = file.type.split('/')
        const [acceptLeft, acceptRight] = accept.split('/')

        if (acceptLeft && acceptRight) {
           if (acceptLeft === '*' && acceptRight === '*') {
              return true
           }

           if (acceptLeft === typeLeft && acceptRight === '*') {
              return true
           }

           if (acceptLeft === typeLeft && acceptRight === typeRight) {
              return true
           }
        }
     } else if (file.extension) {
        const ext = accept.substring(1)
        return file.extension.toLowerCase() === ext.toLowerCase()
     }

     return false
  })
}
